import { render, staticRenderFns } from "./EditFilter.vue?vue&type=template&id=924cd620&scoped=true&"
import script from "./EditFilter.vue?vue&type=script&lang=js&"
export * from "./EditFilter.vue?vue&type=script&lang=js&"
import style0 from "./EditFilter.vue?vue&type=style&index=0&id=924cd620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924cd620",
  null
  
)

export default component.exports